<template>
  <div>
    <section class="gs1-background-color-orange">
      <div class="container">
        <div class="row">
          <div class="col-12 gs1-pt-spacer-6 gs1-pb-spacer-6">
            <h1 class="mb-2 text-white">GPC Browser</h1>
            <p class="gs1-subtitle mb-0 text-white">
              The GPC browser allows you to browse all components (Segment,
              Family, Class, Brick and Attribute) of the current GPC schema.
            </p>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Commented this section because Attibute value issue has been resolved. -->
    <!-- <section>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="mb-0 gs1-text">
              <b>Warning:</b> Please be advised that GPC Browser page is experiencing
              an issue in the display of attribute values and GS1 GO IT
              department is aware and working on a solution. In the meantime,
              please download a copy of the GPC schema from the
              <a
                @click="trackEventBeforeRedirect('standards page')"
                href="https://www.gs1.org/standards/gpc" target="_"
                >standards page</a>
              and use excel to search the standard.
            </p>
          </div>
        </div>
      </div>
    </section> -->
    
    <section class="gs1-background-color-ui-1 gs1-pt-spacer-5">
      <browser
        @onLanguageChange="handleLanguageChange"
        @onPublicationChange="handlePublicationChange"
        class="p-3 bg-white border border-1 rounded"
      ></browser>
    </section>
    <section class="gs1-background-color-ui-1">
      <BrowserDownload
        :selectedLanguage="selectedLanguage"
        :selectedPublication="selectedPublication"
      ></BrowserDownload>
    </section>
    <section class="gs1-background-color-blue">
      <div class="container gs1-pt-spacer-4 gs1-pb-spacer-5">
        <div class="row">
          <div class="col-12">
            <h3 class="mb-4 text-white">Any questions?</h3>
            <p class="text-white mb-5">
              We can help you to get started with GPC.
            </p>
            <GS1LinkButton
              @click="trackEventBeforeRedirect('Contact your local GS1 office')"
              link="https://www.gs1.org/contact"
              class="orange"
              text="Contact your local GS1 office"
            ></GS1LinkButton>
          </div>
        </div>
      </div>
    </section>
    <section class="gs1-background-color-ui-1">
      <div class="container">
        <div class="row gs1-pt-spacer-6 gs1-pb-spacer-4">
          <h3 class="mb-4">Find out more</h3>
          <div class="col-12">
            <div>
              <p>
                <a
                  @click="trackEventBeforeRedirect('GPC Browser Guide')"
                  href="https://www.gs1.org/sites/gs1/files/docs/gpc/GPC-Browser-Guide.pdf"
                  >GPC Browser Guide</a
                >
              </p>
              <p>
                <a
                  @click="
                    trackEventBeforeRedirect(
                      'GPC Browser Service User Guide video'
                    )
                  "
                  href="https://www.youtube.com/watch?v=0ef1PX7RRrA" target="_"
                  >GPC Browser Service User Guide Video</a
                >
              </p>
              <p>
                <a
                  @click="
                    trackEventBeforeRedirect(
                      'GPC Development &amp; Implementation Guide'
                    )
                  "
                  href="https://gs1go2.azureedge.net/cdn/ff/sPhCuyCzpmueHnVAaVIFlQZPvTo6dJcfxi02DSCaVg8/1675886575/public/inline-files/202301-gs1-gpc-development-and-implementation-guideline.pdf"
                  >GPC Development &amp; Implementation Guide</a
                >
              </p>
              <p>
                <a
                  @click="trackEventBeforeRedirect('FAQs on Global Product')"
                  href="https://xchange.gs1.org/sites/faq/Pages/topic.aspx?t=GPC"
                  >FAQs on Global Product</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Browser from "../components/browser/Browser.vue";
import BrowserDownload from "../components/browser/BrowserDownload.vue";
import GS1LinkButton from "../components/shared/GS1LinkButton.vue";
import { ref } from "@vue/reactivity";
import useGtm from "../composables/useGtm";

export default {
  components: { Browser, GS1LinkButton, BrowserDownload },
  setup() {
    const { trackEvent } = useGtm();

    const selectedLanguage = ref({});
    const selectedPublication = ref(null);

    const handleLanguageChange = (language) => {
      selectedLanguage.value = language;
    };
    const handlePublicationChange = (publication) => {
      selectedPublication.value = publication;
    };

    const trackEventBeforeRedirect = (title) => {
      trackEvent("gpc_link_click", {
        title: title,
      });
    };

    return {
      selectedLanguage,
      selectedPublication,
      handleLanguageChange,
      handlePublicationChange,
      trackEventBeforeRedirect,
    };
  },
};
</script>

<style scoped>
.spinner-download {
  height: 1.25rem;
  width: 1.25rem;
}
</style>
